var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTopBarBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.64062C0.09375 9.10938 0.09375 9.92969 0.601562 10.3984L8.10156 17.8984C8.57031 18.4062 9.39062 18.4062 9.85938 17.8984C10.3672 17.4297 10.3672 16.6094 9.85938 16.1406L3.25781 9.5L9.85938 2.89844C10.3672 2.42969 10.3672 1.60938 9.85938 1.14062C9.39062 0.632812 8.57031 0.632812 8.10156 1.14062L0.601562 8.64062Z",
    fill: "#FFFAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopBarBack);
export default __webpack_public_path__ + "static/media/icon-top-bar-back.575e3e5eafbb3664fa5552a95c9fd061.svg";
export { ForwardRef as ReactComponent };